export default __webpack_public_path__ + "static/media/docbox-logo.cbdbf083.png";